import React, { ReactElement } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { ConfigurableProductOptionsValues, Maybe } from '@pylot-data/fwrdschema'
export type Option = {
    displayName: string
    values: Maybe<ConfigurableProductOptionsValues[]>
}

export const VariantCount = ({
    displayName,
    values
}: Option): ReactElement | null => {
    const { t } = useTranslation(['common'])
    const optionCount = values?.length
    if (!optionCount) return null
    const attributeLabel = displayName.toLowerCase()
    return (
        <div className="variant-count-container">
            {t('{{optionCount}} {{attributeLabel}} available', {
                optionCount,
                attributeLabel:
                    optionCount > 1 ? `${attributeLabel}s` : attributeLabel
            })}
        </div>
    )
}
